import { Component } from '@angular/core';

@Component({
  selector: 'app-matspinner',
  templateUrl: './matspinner.component.html',
  styleUrls: ['./matspinner.component.css']
})
export class MatspinnerComponent {

}
